/* eslint-disable */ 
import Vue from 'vue';
import App from './App.vue';
import BootstrapVue from 'bootstrap-vue';
import router from './router';
import Breadcrumbs from './components/bread_crumbs';
import { store } from './store';
import Vue2Filters from 'vue2-filters';
import VueSweetalert2 from 'vue-sweetalert2';
import Notifications from 'vue-notification';
import Toasted from 'vue-toasted';
import SmartTable from 'vuejs-smart-table';
import VueFeather from 'vue-feather';

import PxCard  from './components/Pxcard.vue';
Vue.component(PxCard.name, PxCard);

import { Icon } from 'leaflet';
delete Icon.Default.prototype._getIconUrl;

// Multi Language Add
import en from './locales/en.json';
import id from './locales/id.json';
import { defaultLocale, localeOptions } from './constants/config';
import VueI18n from 'vue-i18n';
import VueApexCharts from 'vue-apexcharts';

// Import Theme scss
import './assets/scss/app.scss';

import './plugins/echart'


Icon.Default.mergeOptions({
  iconRetinaUrl: require('./assets/images/vue2leaflet/marker-icon.png'),
  iconUrl: require('./assets/images/vue2leaflet/marker-icon.png')
});

Vue.use(VueFeather);

Vue.use(Toasted,{
  iconPack: 'fontawesome'
});

Vue.component('apexchart', VueApexCharts);
Vue.use(Notifications);
Vue.use(Vue2Filters);
Vue.use(VueSweetalert2);
Vue.use(BootstrapVue);
Vue.use(SmartTable);
Vue.component('Breadcrumbs', Breadcrumbs);
// Vue.use(FunctionalCalendar, {
//   dayNames: ['M', 'T', 'W', 'T', 'F', 'S', 'S']
// });
Vue.use(VueI18n);


const messages = { en: en, id: id };
const locale = (localStorage.getItem('currentLanguage') && localeOptions.filter(x => x.id === localStorage.getItem('currentLanguage')).length > 0) ? localStorage.getItem('currentLanguage') : defaultLocale;
const i18n = new VueI18n({
  locale: locale,
  fallbackLocale: 'en',
  messages,
  silentTranslationWarn: true
});

Vue.config.productionTip = false;


new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app');